export default __webpack_public_path__ + "static/media/image2.c484d07c.png";